import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CTA.css';

const CTA = () => {
  const navigate = useNavigate();

  const handleStartAssessment = () => {
    navigate('/culture-assessment');
  };

  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-headline">Ready to decode your culture?</h2>
          <p className="cta-subtitle">
            Join hundreds of forward-thinking organizations who've transformed their workplace culture with data-driven insights.
          </p>
          <button onClick={handleStartAssessment} className="btn btn-primary cta-button">
            Start Your Free Assessment
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;


